export var CustomFieldLayoutType = /*#__PURE__*/ function(CustomFieldLayoutType) {
    CustomFieldLayoutType[CustomFieldLayoutType["horizontal"] = 0] = "horizontal";
    CustomFieldLayoutType[CustomFieldLayoutType["vertical"] = 1] = "vertical";
    return CustomFieldLayoutType;
}({});
export var defaultCustomFieldHorizontalLayout = {
    mode: 0,
    labelCol: 3,
    inputCol: 9
};
export var defaultCustomFieldVerticalLayout = {
    mode: 1
};
